import validity from "./validity";
import defaultValue from "./defaultValue";

/** By default, this method will strictly return formatted
currency 350 -> $350, 1 -> $1 etc.
Does not handle decimal formatting **/
export const getCurrency = value => {
  const formattedCurrency = value ? `$${parseInt(value).toLocaleString('en-US')}` : '';
  return formattedCurrency;
};
export const formatCurrency = (value = '') => {
  if (value) {
    const formattedNumber = getCurrency(value);
    const hasDecimal = value.includes('.');
    const formattedDecimal = `.${value.split('.')[1]}`;
    return hasDecimal ? `${formattedNumber}${formattedDecimal}` : formattedNumber;
  }
};
export const getValue = previewEntry => {
  const {
    style,
    value,
    default: defaultValue,
    minimum = ''
  } = previewEntry;
  const specialCases = ['', 0];
  const entryValue = specialCases.includes(value) ? value : value || defaultValue || '';
  if (`${style}` === `4`) {
    const currencyValue = formatCurrency(`${entryValue}`);
    return currencyValue;
  }
  if (`${style}` === `1`) {
    const incrementValue = [0].includes(value) ? value : value || defaultValue || minimum || '';
    return `${incrementValue}`;
  }
  return `${entryValue}`;
};
export default {
  validity,
  defaultValue,
  type: 'Number'
};